var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" 消息1 "),_c('router-link',{attrs:{"to":"/c1/c11/detail?id=666"}},[_vm._v("111")]),_c('router-link',{attrs:{"to":_vm.getUrl(777)}},[_vm._v("222")]),_c('br'),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }